import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ParameterTypeEnum } from '@commons/enums/parameter-type.enum';

import { Vehicle } from '@commons/models/domain/Vehicle';
import { VehicleControlIndicator } from '@commons/models/domain/VehicleControlIndicator';

@Component({
  selector: 'app-fuel-status',
  templateUrl: './fuel-status.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
})
export class FuelStatusComponent {

  @Input('data') set data(value: Vehicle) {
    this.calculate(value);
  }

  public fuelState?: VehicleControlIndicator | null;

  constructor() { }

  private calculate(data: Vehicle): void {
    const control = data.ControlIndicators?.find(item => item.Tp === ParameterTypeEnum.Fuel && item.LV);
    if (control) {
      this.fuelState = control;
    }
  }

}
